import { AuthProvider } from "./components/context/AuthProvider";
import RegisteredRoutes from "./components/routes/RegisteredRoutes";
import { ToastProvider } from "./components/ui/Toast";
import { WebSocketProvider } from "./contexts/WebSocketContext";
import { useAuth } from "./components/context/AuthProvider";
import SessionNotificationHandler from "./components/business/SessionNotificationHandler";
import { WalkthroughProvider } from "./contexts/WalkthroughContext";

// Component that provides WebSocket with auth context
function AppWithWebSocket() {
  const auth = useAuth();

  const userId = auth.get("userId");
  const username = auth.get("username");
  const token = auth.token();

  // Generic WebSocket config for global notifications
  const wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  const webSocketConfig = {
    url: `${wsProtocol}//${window.location.host}/ws`,
    userId: String(userId || ""),
    username: username || "",
    token: token || "",
    reconnectInterval: 3000,
    maxReconnectAttempts: 5,
    autoReconnect: true,
    // No session-specific data in config anymore
  };

  return (
    <WebSocketProvider config={webSocketConfig} autoConnect={!!token}>
      <ToastProvider>
        <SessionNotificationHandler />
        <WalkthroughProvider>
          <RegisteredRoutes />
        </WalkthroughProvider>
      </ToastProvider>
    </WebSocketProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppWithWebSocket />
    </AuthProvider>
  );
}

export default App;
